<template>
  <div>
    <CardedSectionHeader
      icon="mdi-plus"
      label="Create A Promotions Event"
      id="owner_promotions_form_section"
      v-if="is_editing == false"
    ></CardedSectionHeader>
    <CardedForm
      ref="owner_promotions_form_ref"
      id="owner_promotions_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="upload_poster"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
    >
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <TextField
            v-model="form.title"
            :validation_rules="form_validations.title"
            label="Promotion's Title"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></TextField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.business_id"
            :options="businesses"
            :small_chips="false"
            :validation_rules="form_validations.business_id"
            label="Attach A Business/Company"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
      </v-row>

      a small image of dimensions
      <b>250 pixels (width) X 250 pixels (height)</b>
      <ImageField
        label="Promotion's Thumb Nail Image"
        icon="mdi-camera"
        :disabled="is_loading"
        folder="promotionthumbnails"
        @on-hide-loader="hide_loader"
        @on-show-loader="show_loader"
        @on-success="on_finished_thumbnail_upload"
        @on-error="on_thumbnail_upload_errors"
        ref="thumbnail_image_uploader"
        :required="images_required"
        empty_file_error="Please Select A Thumbnail Image For the Promotion"
        :default_value="default_promotion_thumbnail"
        :messages="thumbnail_messages"
      >
      </ImageField>

      <TextArea
        v-model="form.description"
        :validation_rules="form_validations.description"
        label="Describe In Details Your Promotion Event"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextArea>

      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <DateField
            label="Start Date"
            v-model="form.starts_on"
            :disabled="is_loading"
            cmp_class="mt-0 mb-0 pb-0 pt-0"
            :min="date_today"
            :max="form.ends_on"
          ></DateField>
        </v-col>
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <DateField
            label="End Date"
            v-model="form.ends_on"
            :disabled="is_loading"
            :min="form.starts_on"
            :max="max_end_date"
            cmp_class="mt-0 mb-0 pb-0 pt-0"
          ></DateField>
        </v-col>
      </v-row>

      <ImageField
        label="Promotion's Poster Image"
        icon="mdi-camera"
        :disabled="is_loading"
        folder="promotionposters"
        @on-hide-loader="hide_loader"
        @on-show-loader="show_loader"
        @on-success="on_finished_poster_upload"
        @on-error="on_poster_upload_errors"
        ref="poster_image_uploader"
        :required="images_required"
        empty_file_error="Please Select A Poster Image For the Promotion"
        :default_value="default_promotion_poster"
        :messages="thumbnail_messages"
      >
      </ImageField>
    </CardedForm>
  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedForm from "../../../components/CardedForm";
import SelectField from "../../../components/SelectField";
import TextField from "../../../components/TextField";
import TextArea from "../../../components/TextArea";
import ImageField from "../../../components/ImageField";
import DateField from "../../../components/DateField";

export default {
  name: "OwnerPrommotionsAdd",
  components: {
    CardedSectionHeader,
    CardedForm,
    SelectField,
    TextField,
    TextArea,
    ImageField,
    DateField,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_editing: {
      type: Boolean,
      default: false,
    },
    promotion_to_edit: {
      type: Object,
      default: () => {
        return Utils.get_default_promotion();
      },
    },
  },
  data: function () {
    return {
      cmp_user: null,
      errors: [],
      message: "",
      form: {
        business_id: null,
        title: "",
        description: "",
        media_url: "",
        thumbnail_url: "",
        starts_on: "",
        ends_on: "",
      },
      form_validations: {
        business_id: [],
        title: [
          Utils.validate.is_required("Promotion's title is required"),
          Utils.validate.min_max_length(
            10,
            100,
            "Promotion's title should be between 10 and 100 characters "
          ),
        ],
        description: [
          Utils.validate.is_required("Promotion's description is required"),
          Utils.validate.min_max_length(
            50,
            600,
            "Promotion's description should be between 50 and 600 characters "
          ),
        ],
        media_url: [
          Utils.validate.is_required("Promotions's poster image is required"),
        ],
        thumbnail_url: [
          Utils.validate.is_required(
            "Promotions's thumbnail image is required"
          ),
        ],
        starts_on: [],
        ends_on: [],
      },
      businesses: [],
      default_promotion_poster: Utils.default_promotion_poster,
      default_promotion_thumbnail: Utils.default_promotion_thumbnail,
      images_required: true,
      date_today: Utils.get_today_date_str(),
      max_end_date: new Date().getFullYear() + 1 + "-01-01",
      thumbnail_messages: [],
      media_messages: [],
    };
  },
  methods: {
    on_auto_fill() {
      if (this.is_editing == true) {
        this.form.business_id = parseInt(this.promotion_to_edit.business_id);
        this.form.title = this.promotion_to_edit.title;
        this.form.description = this.promotion_to_edit.description;
        this.form.media_url = this.promotion_to_edit.media_url;
        this.form.thumbnail_url = this.promotion_to_edit.thumbnail_url;
        this.form.starts_on = this.promotion_to_edit.starts_on;
        this.form.ends_on = this.promotion_to_edit.ends_on;
        var thumb_url_parts = this.promotion_to_edit.thumbnail_url.split("/");
        this.thumbnail_messages = [
          "Current Image: " + thumb_url_parts[thumb_url_parts.length - 1],
        ];
        var medial_url_parts = this.promotion_to_edit.media_url.split("/");
        this.media_messages = [
          "Current Image: " + medial_url_parts[medial_url_parts.length - 1],
        ];
      } else {
        this.thumbnail_messages = [];
        this.media_messages = [];
        var rnd = Math.ceil(Math.random() * 97869);
        this.form.business_id =
          this.businesses.length > 0 ? this.businesses[0].id : null;
        this.form.title = rnd + "_@ Super Duper New Years Discount";
        this.form.description =
          rnd +
          "_@ Hear at our cool company we know that starting of the yaer has to begin in greate fashion";
        this.form.description +=
          " so we have cut the prices of the items that you so much dearly love and enjoy ";
        this.form.description +=
          " giving you so much value for your hard earned money.  ";
        this.form.description +=
          " All Items have been cut to 20% discrount starting this Jan 2021   ";

        this.form.media_url = this.default_promotion_poster;
        this.form.thumbnail_url = this.default_promotion_thumbnail;
        (this.form.starts_on = Utils.get_today_date_str()),
          (this.form.ends_on = Utils.get_today_date_str());
      }
      this.max_end_date = new Date().getFullYear() + 1 + "-01-01";
      this.errors = [];
      this.message = "";
      this.$refs.owner_promotions_form_ref.on_clear_validations();
    },
    init_form() {
      if (this.is_editing == true) {
        this.form.business_id = parseInt(this.promotion_to_edit.business_id);
        this.form.title = this.promotion_to_edit.title;
        this.form.description = this.promotion_to_edit.description;
        this.form.media_url = this.promotion_to_edit.media_url;
        this.form.thumbnail_url = this.promotion_to_edit.thumbnail_url;
        this.form.starts_on = this.promotion_to_edit.starts_on;
        this.form.ends_on = this.promotion_to_edit.ends_on;
        var thumb_url_parts = this.promotion_to_edit.thumbnail_url.split("/");
        this.thumbnail_messages = [
          "Current Image: " + thumb_url_parts[thumb_url_parts.length - 1],
        ];
        var medial_url_parts = this.promotion_to_edit.media_url.split("/");
        this.media_messages = [
          "Current Image: " + medial_url_parts[medial_url_parts.length - 1],
        ];
        this.default_promotion_thumbnail = this.promotion_to_edit.thumbnail_url;
        this.default_promotion_poster = this.promotion_to_edit.media_url;
        this.images_required = false;
      } else {
        this.thumbnail_messages = [];
        this.media_messages = [];
        this.form.business_id = null;
        this.form.title = "";
        this.form.description = "";
        this.form.media_url = "";
        this.form.thumbnail_url = "";
        (this.form.starts_on = Utils.get_today_date_str()),
          (this.form.ends_on = Utils.get_today_date_str());
      }
      this.max_end_date = new Date().getFullYear() + 1 + "-01-01";
      this.errors = [];
      this.message = "";
      this.$refs.owner_promotions_form_ref.on_clear_validations();
    },
    hide_loader() {
      this.$emit("on-hide-loader");
    },
    show_loader() {
      this.$emit("on-show-loader");
    },
    upload_poster() {
      this.$refs.poster_image_uploader.upload_file();
    },
    on_finished_poster_upload(file_url) {
      this.form.media_url = file_url;
      this.upload_thumbnail();
    },
    on_poster_upload_errors(errors) {
      this.errors = errors;
      this.$refs.owner_promotions_form_ref.show_error_dialog();
    },
    upload_thumbnail() {
      this.$refs.thumbnail_image_uploader.upload_file();
    },
    on_finished_thumbnail_upload(file_url) {
      this.form.thumbnail_url = file_url;
      this.submit();
    },
    on_thumbnail_upload_errors(errors) {
      this.errors = errors;
      this.$refs.owner_promotions_form_ref.show_error_dialog();
    },
    submit() {
      this.errors = [];
      this.message = "";

      var start_time_str = this.form.starts_on + " 00:30:00 AM ";
      var start_time = Utils.date_str_to_php_time(start_time_str);
      var end_time_str = this.form.ends_on + " 11:30:00 PM ";
      var end_time = Utils.date_str_to_php_time(end_time_str);
      if (start_time == end_time) {
        this.errors.push("Start time cannot be equal to end time");
        this.$refs.owner_promotions_form_ref.show_error_dialog();
        return false;
      }
      if (start_time > end_time) {
        this.errors.push("Start time cannot be greater than end time");
        this.$refs.owner_promotions_form_ref.show_error_dialog();
        return false;
      }

      //images
      this.form.media_url = this.form.media_url.trim();
      if (this.form.media_url.length == 0) {
        this.errors.push("Please upload a poster image for your promotion ");
        this.$refs.owner_promotions_form_ref.show_error_dialog();
        return false;
      }
      this.form.thumbnail_url = this.form.thumbnail_url.trim();
      if (this.form.thumbnail_url.length == 0) {
        this.errors.push("Please upload a thumbnail image for your promotion ");
        this.$refs.owner_promotions_form_ref.show_error_dialog();
        return false;
      }

      //the business
      var bid =
        this.form.business_id == null ? 0 : parseInt(this.form.business_id);
      if (bid == 0) {
        this.errors.push(
          "Please select a business attached to this promotion "
        );
        this.$refs.owner_promotions_form_ref.show_error_dialog();
        return false;
      }

      this.show_loader();
      if (this.is_editing == true) {
        ServerClient.Promotions.update_promotion(
          {
            data: {
              ...this.form,
              starts_on_timestamp: start_time,
              ends_on_timestamp: end_time,
            },
            id: this.promotion_to_edit.id
          },
          (res) => {
            this.hide_loader();
            this.message =
              "<b>Operation was successfull</b> <br/>  Your promotion has been updated successfully";
            this.$refs.owner_promotions_form_ref.show_message_dialog();
          },
          (errors) => {
            //console.log("These errors are wonderfull ", errors);
            this.hide_loader();
            this.errors = errors;
            this.$refs.owner_promotions_form_ref.show_error_dialog();
          }
        );
      } else {
        ServerClient.Promotions.create_promotion(
          {
            ...this.form,
            user_id: this.cmp_user.id,
            starts_on_timestamp: start_time,
            ends_on_timestamp: end_time,
          },
          (res) => {
            this.hide_loader();
            this.message =
              "<b>Operation was successfull</b> <br/>  Your promotion has been created successfully";
            this.$refs.owner_promotions_form_ref.show_message_dialog();
          },
          (errors) => {
            //console.log("These errors are wonderfull ", errors);
            this.hide_loader();
            this.errors = errors;
            this.$refs.owner_promotions_form_ref.show_error_dialog();
          }
        );
      }
    },
    on_hide_message() {
      if (this.is_editing == true) {
        this.$emit("on-updated-promotion");
      }else{
        this.init_form();
      }
    },
    load_my_businesses() {
      this.show_loader();
      ServerClient.Businesses.get_my_buinesses(
        {
          user_id: this.cmp_user.id,
        },
        (res) => {
          this.businesses = res;
          this.init_form();
          this.hide_loader();
        },
        (errors) => {
          this.hide_loader();
          console.log(
            "Errors loading my businesss on owners add prmotions form"
          );
        }
      );
    },
  },
  mounted() {
    this.cmp_user = ServerClient.Login.get_logged_in_user();
    //nyd
    //if the _user is not there  then just take this dude
    //to the loggin screen

    this.$emit("set-page-attributes", {
      title: "Promotions Form ",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Promotions",
          disabled: false,
          href: "/owner/promotions",
        },
        {
          text: "Add",
          disabled: true,
          href: "/owner/promotions/add",
        },
      ],
      navbar_cols: 3,
    });

    this.load_my_businesses();
  },
};
</script>